const { getStorage } = require('helpers/general');

const getDate = (oneYearLater = true) => {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = d.getDate();
  if (!oneYearLater) {
    return `${year}${month}${day}`;
  }
  return new Date(year + 1, month, day);
};

const stripHtmlTags = html => {
  let plainText = html.replace(/<[^>]*>/g, '');
  plainText = plainText
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/&/g, '&')
    .replace(/"/g, '"')
    .replace(/'/g, "'")
    .replace(/ /g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&reg;/g, '®')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\\r\\n/g, ' ')
    .replace(/&apos;/g, "'")
    .replace(/\\n/g, '');
  return plainText;
};

const isMadPawsStore = (store = null) => {
  const currentStore = store || process.env.GATSBY_STORE;
  const isMadPawsStore = currentStore === 'MPS';
  return isMadPawsStore;
};

const storeStyle = ({ store = null, mpsStyles, pcStyles }) => {
  const styles = isMadPawsStore(store) ? mpsStyles : pcStyles;
  return styles;
};

const railwayApi = async (url, method = 'GET', body = null) => {
  try {
    const token = getStorage('_loggedIn');
    if (!token) {
      return;
    }
    const apiUrl = process.env.GATSBY_BC_API;
    const request = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'authorization-BC': token
      }
    };

    if (body && method !== 'GET') {
      request.body = JSON.stringify(body);
    }

    const response = await fetch(`${apiUrl}/${url}`, request);
    const textResponse = await response.text();
    if (!textResponse) return textResponse;
    const res = await JSON.parse(textResponse);
    return res;
  } catch (error) {
    console.error('Error fetching data from Railway API:', error);
    return { success: false, message: 'Failed to fetch data' };
  }
};

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

module.exports = { getDate, stripHtmlTags, storeStyle, isMadPawsStore, delay, railwayApi };
